import { IconName } from '@optimus-web/icons';
import { FeatureFlag } from '@mews-commander/enums';
import { AssistantRoutingRule } from '@mews-commander/data-access';
import { useFeatureFlag } from '@mews/framework';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useEnterpriseBuildLocation } from '@mews-commander/ui';
import { ResultListProps } from '../results/ListTitle';
import { highlight } from '../../utils/highlight';
import { navigateInBaseModal } from '../../../app/actions/common';
import { SearchType } from '../../assistantSearchTypes';
import { StyledLeftIcon } from '../styles';
import { AssistantSearchListItemProps } from './useAssistantSearchResultListMap';

interface RoutingRuleListProps extends ResultListProps {
    routingRules: AssistantRoutingRule[];
}

interface PrimaryTextProps {
    routingRule: AssistantRoutingRule;
    searchTerm: string;
}

const PrimaryText = ({ routingRule, searchTerm }: PrimaryTextProps) => {
    const title = highlight(routingRule.name ?? '', searchTerm);
    return <>{title}</>;
};

export const useRoutingRuleList = ({
    routingRules,
    searchTerm,
}: RoutingRuleListProps): AssistantSearchListItemProps[] => {
    const buildLocation = useEnterpriseBuildLocation();
    const currentEnterpriseId = useCurrentEnterpriseId();
    const isNewRoutingRulesOnAddEnabled = useFeatureFlag(FeatureFlag.newRoutingRulesOnAddEnabled);
    if (!isNewRoutingRulesOnAddEnabled) {
        return [];
    }
    return routingRules.map((routingRule) => {
        const url = buildLocation({
            to: 'RoutingRule/Detail/$routingRuleId',
            params: { routingRuleId: routingRule.id, currentEnterpriseId },
            search: { EnterpriseId: currentEnterpriseId },
        }).href;
        return {
            itemId: routingRule.id || '',
            primaryText: <PrimaryText routingRule={routingRule} searchTerm={searchTerm} />,
            leftIcon: <StyledLeftIcon size="small" value={IconName.LightningBolt} />,
            routeAction: navigateInBaseModal(url),
            searchType: SearchType.RoutingRule,
        };
    });
};
